import { atom, useAtom } from "jotai";
import { atomFamily } from "jotai/utils";
import { useCallback } from "react";

import { usePaneId } from "../../pane/context";

export type PraMockPage = { name: string; active: boolean };

/** Picking PRA in Add Page opens this in-memory page until page types are stored. */
const praMockPageFamily = atomFamily((_paneId: string) => atom<PraMockPage | null>(null));

export const usePraMockPage = () => {
  const [page, setPage] = useAtom(praMockPageFamily(usePaneId()));
  const open = useCallback((name: string) => setPage({ name, active: true }), [setPage]);
  const activate = useCallback(() => setPage((p) => p && { ...p, active: true }), [setPage]);
  const deactivate = useCallback(() => setPage((p) => p && { ...p, active: false }), [setPage]);
  return { page, open, activate, deactivate };
};
